/**
 * Explicit Logout Flag — prevents Supabase SDK "SIGNED_OUT" ghost events.
 *
 * Problem: Supabase SDK occasionally fires SIGNED_OUT without user action
 * (e.g., during token refresh race conditions). This module ensures we only
 * clear session state when the user explicitly clicked logout.
 *
 * Borrowed from MuseSea auth hardening (12 rounds of fixes).
 *
 * @see Issue #88, Issue #79
 */

const KEY = "ig-explicit-logout";

export function markExplicitLogout(): void {
  try {
    sessionStorage.setItem(KEY, "1");
  } catch {
    /* SSR/test fallback */
  }
}

export function isExplicitLogout(): boolean {
  try {
    return sessionStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function clearExplicitLogout(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}